<template>
  <v-row class="fill-height">
    <v-col cols="5">
      <orgTreeView v-model="selectedNode" ref="orgTree" />
    </v-col>
    <v-divider vertical></v-divider>
    <v-col class="text-center align-center" cols="6">
      <orgUserCard :user="currentUser" :mode="'edit'" @onUserUpdate="doEmployeeChanged"/>
    </v-col>
    <addEmployeeDialog v-model="showAddEmployeeDialog" :org="org" :division="currentDivision" :user="addEmployeeUser" :mode="addEmployeeMode" @onEmployeeAdded="doEmployeeAdded" @onEmployeeUpdated="doEmployeeChanged" />
    <moveEmployeeDialog v-model="showMoveEmployeeDialog" :org="org" :user="moveEmployeeUser" @onEmployeeMoved="doEmployeeMoved" />
    <addDivisionDialog v-model="showAddDivisionDialog" :org="org" :division="currentDivision" :mode="addDivisionMode" @onDivisionAdded="doDivisionAdded" @onDivisionChanged="doDivisionChanged" />
    <poUserDialog
      v-model="showPOUserDialog"
      :user="currentUser"
      @onUserCreate="doEmployeeChanged"
      @onUserLocked="doEmployeeChanged"
      @onUserUnlocked="doEmployeeChanged"
      @onUserRoleChanged="doEmployeeChanged"
    />
    <sys-confirm-dialog v-model="showConfirmDialog" :message="currentDelMessage" :ok-call-back="currentConfirmAction" :no-call-back="doCloseConfirmDialog" />
  </v-row>
</template>

<script>
import orgTreeView from '@/components/modules/org/structure/orgTree.vue'
import orgUserCard from '@/components/modules/org/structure/staff/userCard.vue'
import { cptyStructureMgmtMixin } from '@/components/modules/org/clients/counterparties/mixins/cptyStructureMgmt'
import { ORG_GET_ORG } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'orgStructureIndex',
  components: {
    orgTreeView,
    orgUserCard
  },
  mixins: [cptyStructureMgmtMixin],
  data () {
    return {
      selectedNode: undefined
    }
  },
  computed: {
    org: {
      get: function () {
        return this.$store.getters.getCurrentOrg
      }
    }
  },
  watch: {
  },
  methods: {
  },
  mounted: function () {
    console.log('orgStructureIndex mounted')
    this.$store.dispatch(ORG_GET_ORG, {})
      .catch((err) => {
        this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка получения профиля организации' + err })
      })
  }

}
</script>
